import { createSelector } from '@ngrx/store';

import * as fromFeature from '../../reducers/index';
import * as fromTaxDocumentUpload from '../../reducers/tax-document-upload/tax-document-upload.reducer';
import { selectDecedentInheritanceWaiverState } from '../decedent-info/decedent-info.selectors';
import { selectCurrentTransaction } from '../transaction-state/transaction-state.selectors';

export const selectTaxDocumentUploadState = createSelector(
  fromFeature.getTaxDocumentUploadState,
  (state) => state,
);

export const selectTaxFilesMetadata = createSelector(
  fromFeature.getTaxDocumentUploadState,
  (state) => {
    return state.filesMetaData;
  },
);

export const selectIsTaxDocumentInState = createSelector(
  selectTaxDocumentUploadState,
  fromTaxDocumentUpload.getHasClientUploadedFile,
);

export const selectHasClientUploadedL8File = createSelector(
  selectTaxDocumentUploadState,
  selectDecedentInheritanceWaiverState,
  selectCurrentTransaction,
  (state, inheritanceWaiverState, currentTransactionState) => {
    return fromTaxDocumentUpload.getHasClientUploadedL8OrITWFile(
      state,
      inheritanceWaiverState,
      currentTransactionState || ({} as fromFeature.TransactionState),
    );
  },
);

export const selectTaxCheckboxSelections = createSelector(
  fromFeature.getTaxDocumentUploadState,
  (state) => state.checkboxSelections,
);

export const selectIsL8ITWUploadPageVisited = createSelector(
  fromFeature.getTaxDocumentUploadState,
  (state) => state.isL8ITWUploadPageVisited ?? false,
);
